module.exports = __webpack_public_path__ + "03_long_brown.c16b71dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_long_brown.png
// module id = 4mIT
// module chunks = 0